import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Card from '../../../../../../component/Card';
import Form from '../../../../../../component/Form';
import Service from '../../../../../../../apiService';
import withFormLogic from '../../../../../../hoc/withFormLogic';
import withPostFetch from '../../../../../../hoc/withPostFetch';
import Alert from '../../../../../../component/Alert';
import ReactToPrint from 'react-to-print';
import '../../../../../form.css';
import JasaBogaPersyaratan from './JasaBogaPersyaratan';
import View from './View';

class NumberManipulation {
  constructor() {
    this.list = [];
  }

  simplifyNumber = (number) => {
    if (this.list.includes(number)) return this.list.indexOf(number);
    else {
      this.list.push(number);
      return this.list.indexOf(number);
    }
  };
}

const fieldNumber = new NumberManipulation();
const fieldValidationNumber = new NumberManipulation();

const fieldValidation = [];

const Form2 = ({
  field,
  onChangeHandler,
  onChangeHandlerWithIndex,
  onChangeProgrammatically,
  submitHandler,
  validation,
  post,
  onLoad,
  existingData,
  existingPersyaratan,
  idPendaftaran,
  setIsProgressHidden,
  nextStep,
  setStep,
  isShow,
}) => {
  const [kerangka, setKerangka] = useState({});
  const [formDisabled, setFormDisabled] = useState(true);
  const [persyaratanDisabled, setPersyaratanDisabled] = useState(true);
  const [persyaratan, setPersyaratan] = useState([]);
  const [filePersyaratan, setFilePersyaratan] = useState([]);
  const [validationPersyaratan, setValidationPersyaratan] = useState([]);
  const [fieldState, setFieldState] = useState([]);
  const [isUploading, setIsUploading] = useState({});
  const [wasValidate, setWasValidate] = useState(false);
  const [didMount, setDidMount] = useState(false);
  const contentRef = useRef();
  const printRef = useRef();

  // useEffect(() => setDidMount(true), []);

  const getKerangkaHigine = async () => {
    try {
      const response = await Service.get('/department/foodhigiene/read');
      if (response) {
        setKerangka(response.data);
      }
    } catch (error) {
      return [];
    }
  };

  const filterParams = (params) => {
    for (const key in params) {
      if (typeof params[key] !== 'string')
        params[key] = params[key].filter((value) => value);
      else params[key] = params[key];
    }
    return params;
  };

  const setPerusahaanId = (data) => {
    onChangeProgrammatically('pendaftaran_perusahaan_id', data);
  };

  const setValue = (datas) => {
    const array = [];
    const subArray = [];
    datas.forEach((data) => {
      if (!data.sub_categories.length) {
        if (data.value) {
          array[fieldNumber.simplifyNumber(data.id)] = {
            ref_foodhigiene_categories_id: data.id,
            value: data.value,
          };
        }
      } else {
        data.sub_categories.forEach((sub_categorie) => {
          sub_categorie.sub_sub_categories.forEach((sub_sub_categorie) => {
            if (sub_sub_categorie.value) {
              subArray[fieldNumber.simplifyNumber(sub_sub_categorie.id)] = {
                ref_foodhigiene_sub_sub_categories_id: sub_sub_categorie.id,
                value: sub_sub_categorie.value,
              };
            }
          });
        });
      }
    });
    return { array, subArray };
  };

  const getBase64 = (file, index, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
      setIsUploading((state) => {
        return { ...state, [index]: false };
      });
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  const fileValidator = (file, validationRule) => {
    const validationStatus = [{ valid: true }];
    const fileExtension = file.type.split('/')[1];
    const validationList = validationRule.extension
      .split(',')
      .map((value) => value);

    const extensionValidator = validationList.includes(fileExtension);
    const sizeValidator = file.size <= validationRule.max_size;

    if (!extensionValidator) {
      validationStatus.push({
        valid: extensionValidator,
        message: `Ekstensi harus ${validationRule.extension}`,
      });
    }
    if (!sizeValidator) {
      validationStatus.push({
        valid: extensionValidator,
        message: `Ukuran lebih dari ${validationRule.max_size / 1000} MB `,
      });
    }

    return validationStatus[validationStatus.length - 1];
  };

  const setFile = (e, index, syarat) => {
    const name = e.target.name;

    const file = e.target.files[0];

    if (!file) return '';

    const isValid = fileValidator(file, syarat);

    if (isValid.valid) {
      setValidationPersyaratan((state) => {
        return { ...state, [index]: '' };
      });
      setIsUploading((state) => {
        return { ...state, [index]: true };
      });
      getBase64(file, index, (result) => {
        setFilePersyaratan((state) => {
          return {
            ...state,
            [index]: {
              ref_persyaratan_id: name,
              trx_pend_perusahaan_id: field.pendaftaran_perusahaan_id,
              upload: result,
            },
          };
        });
      });
    } else {
      setValidationPersyaratan((state) => {
        return { ...state, [index]: isValid.message };
      });
    }
  };

  const convertToArray = (array) => {
    const result = Object.values(array).map((data) => data);
    return result;
  };

  const postPersyaratan = async (param) => {
    const result = await Service.post('/department/persyaratan/upload', param);
    return await result;
  };

  const openFile = (url) => {
    const win = window.open(url, '_blank');
    if (!win) {
      win.focus();
    }
  };

  const setFieldValidation = (index, state) => {
    fieldValidation[index] = state;
  };

  const initiateFieldValidation = (index, state) => {
    if (fieldValidation[index]) return '';
    fieldValidation[index] = state;
  };

  const valueCheck = (value, index) =>
    !value &&
    setFieldState((state) => {
      state[index] = false;
      return state; 
    });

  const checkFieldValidation = () => {
    setWasValidate(true);
  };

  const printCode = () => {
    printRef.current.handlePrint();
  };

  const assignValidation = () => setFieldState(fieldValidation);

  // useEffect(() => {
  //   if (didMount) {
  //     assignValidation();
  //     setKerangka(existingData);
  //     const value = setValue(existingData);
  //     onChangeProgrammatically('categories_results', value.array, () =>
  //       onChangeProgrammatically(
  //         'sub_sub_categories_results',
  //         value.subArray,
  //         () => setPerusahaanId(idPendaftaran)
  //       )
  //     );
  //   }
  // }, [existingPersyaratan]);

  return (
    isShow && (
      <>
        <span
          className='text-primary mb-3 d-inline-block'
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setStep(1);
            // setIsProgressHidden(false);
          }}>
          <i
            className='ni ni-curved-next mr-2'
            style={{ transform: 'scaleX(-1)' }}
          />
          <span className='d-inline'>Kembali</span>
        </span>
        <View
          data={existingPersyaratan}
          idPendaftaran={idPendaftaran}
          handleSubmit={() => {}}
        />
        {/* <JasaBogaPersyaratan
          isShow={isShow}
          existingPersyaratan={existingPersyaratan}
          disabled={persyaratanDisabled}
          onAfterPost={() => Alert('success', 'Edit Berhasil')}
          sideTitleElement={
            <span
              className='text-warning ml-2'
              style={{ cursor: 'pointer' }}
              onClick={() => setPersyaratanDisabled(false)}>
              <i className='fa fa-pencil-alt mr-2' />
              <span>Edit</span>
            </span>
          }
        /> */}
        {/* <h1 className='d-inline'>Data JASABOGA </h1>
        <span
          className='text-warning'
          style={{ cursor: 'pointer' }}
          onClick={() => setFormDisabled(false)}>
          <i className='fa fa-pencil-alt mr-2' />
          <span>Edit</span>
        </span>
        <ReactToPrint
          ref={printRef}
          trigger={() => <button className='d-none'></button>}
          content={() => contentRef.current}
        />
        <Form class='mt-4'>
          <Form.Row>
            <Form.Column lg={12} md={12}>
              {kerangka.length &&
                kerangka.map((value, i) => {
                  if (!value.sub_categories.length) {
                    initiateFieldValidation(
                      fieldValidationNumber.simplifyNumber(value.name),
                      value.value ? true : false
                    );
                    return (
                      <Form.TextInput
                        label={value.name}
                        name='categories_results'
                        inputWidth={3}
                        errorMessage={
                          fieldState[
                            fieldValidationNumber.simplifyNumber(value.name)
                          ] || !wasValidate
                            ? ''
                            : 'wajib diisi'
                        }
                        value={
                          field.categories_results[i]
                            ? field.categories_results[i].value
                            : ''
                        }
                        defaultValue={
                          value.value
                            ? value.value
                            : field.categories_results[i]
                            ? field.categories_results[i].value
                            : ''
                        }
                        disabled={formDisabled}
                        onChange={(e) => {
                          onChangeHandlerWithIndex(
                            {
                              target: {
                                name: 'categories_results',
                                value: {
                                  ref_foodhigiene_categories_id: value.id,
                                  value: e.target.value,
                                },
                              },
                            },
                            fieldNumber.simplifyNumber(value.id)
                          );
                          setFieldState((state) => {
                            state[
                              fieldValidationNumber.simplifyNumber(value.name)
                            ] = true;
                            return state;
                          });
                          valueCheck(
                            e.target.value,
                            fieldValidationNumber.simplifyNumber(value.name)
                          );
                        }}
                      />
                    );
                  } else {
                    return value.sub_categories.map((sub_categorie, index) => {
                      return (
                        <>
                          <h2 className={index !== 0 && 'd-none'}>
                            {value.name}
                          </h2>
                          <Form.RadioCustom
                            label={sub_categorie.name}
                            input={({ data, inputType, defaultValue = '' }) => (
                              <input
                                className='form-control form-control-sm'
                                onChange={(e) => {
                                  onChangeHandlerWithIndex(
                                    {
                                      target: {
                                        name: 'sub_sub_categories_results',
                                        value: {
                                          ref_foodhigiene_sub_sub_categories_id: data.toString(),
                                          value: e.target.value,
                                        },
                                      },
                                    },
                                    inputType !== 'checkbox&text'
                                      ? fieldNumber.simplifyNumber(
                                          sub_categorie.id
                                        )
                                      : fieldNumber.simplifyNumber(data),
                                    () =>
                                      setFieldState((state) => {
                                        state[
                                          fieldValidationNumber.simplifyNumber(
                                            sub_categorie.name
                                          )
                                        ] = true;
                                        return state;
                                      })
                                  );
                                }}
                                defaultValue={defaultValue}
                                disabled={formDisabled}></input>
                            )}
                            inputWidth={5}
                            disabled={formDisabled}
                            errorMessage={
                              fieldState[
                                fieldValidationNumber.simplifyNumber(
                                  sub_categorie.name
                                )
                              ] || !wasValidate
                                ? ''
                                : 'wajib diisi'
                            }
                            name={sub_categorie.name}
                            options={sub_categorie.sub_sub_categories.map(
                              (sub_sub_categorie) => {
                                initiateFieldValidation(
                                  fieldValidationNumber.simplifyNumber(
                                    sub_categorie.name
                                  ),
                                  sub_sub_categorie.value ? true : false
                                );
                                return {
                                  label: sub_sub_categorie.name,
                                  value: sub_sub_categorie.id,
                                  inputType: sub_sub_categorie.input_type,
                                  defaultValue: sub_sub_categorie.value,
                                };
                              }
                            )}
                            onChange={(e, inputIndex = 0, checked = true) => {
                              onChangeHandlerWithIndex(
                                {
                                  target: {
                                    name: 'sub_sub_categories_results',
                                    value: checked
                                      ? {
                                          ref_foodhigiene_sub_sub_categories_id:
                                            e.target.value,
                                          value: 1,
                                        }
                                      : null,
                                  },
                                },
                                !inputIndex
                                  ? fieldNumber.simplifyNumber(sub_categorie.id)
                                  : fieldNumber.simplifyNumber(inputIndex),
                                setFieldState((state) => {
                                  state[
                                    fieldValidationNumber.simplifyNumber(
                                      sub_categorie.name
                                    )
                                  ] = true;
                                  return state;
                                })
                              );
                            }}
                          />
                        </>
                      );
                    });
                  }
                })}
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={12}>
              <button
                className='btn btn-primary float-right'
                disabled={formDisabled}
                onClick={() =>
                  submitHandler(validation, field, (params) => {
                    post(filterParams(params), async (response) => {
                      if (!response) {
                        Alert('error', 'Edit Berhasil');
                      } else {
                        Alert('success', 'Edit Berhasil');
                      }
                    });
                  })
                }>
                submit
              </button>
            </Form.Column>
          </Form.Row>
        </Form> */}
        <div className='d-none'>
          <table ref={contentRef}>
            <tr>
              <td>Tanggal</td>
              <td>:</td>
              <td>{Date.now()}</td>
            </tr>
            <tr>
              <td>Kode Pendaftaran</td>
              <td>:</td>
              <td>{field.pendaftaran_perusahaan_id}</td>
            </tr>
          </table>
        </div>
      </>
    )
  );
};

const postDepartement = async (params) => {
  try {
    const response = await Service.post(
      '/department/foodhigiene/create',
      params
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export default withPostFetch((params) => postDepartement(params))(
  withFormLogic({
    pendaftaran_perusahaan_id: '',
    categories_results: [],
    sub_sub_categories_results: [],
  })(Form2)
);
